import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Constructor } from '@mtna/core-ts';

/* eslint-disable @typescript-eslint/ban-types */
/** @docs-private */
export interface CanLoad {
  /** Whether the component is loading. */
  loading: boolean;
}

/** @docs-private */
export type CanLoadCtor = Constructor<CanLoad>;

/** Mixin to augment a directive with a `loading` property. */
export function mixinLoading<T extends Constructor<{}>>(base: T): CanLoadCtor & T {
  return class extends base {
    private _loading = false;

    get loading(): boolean {
      return this._loading;
    }
    set loading(value: boolean) {
      this._loading = coerceBooleanProperty(value);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any[]) {
      super(...args);
    }
  };
}
